import { Injectable, effect, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly _isDark = signal<boolean>(ThemeService.resolveInitialTheme());

  /**
   * For a returning user, honour their saved preference. For a brand-new user
   * (no stored choice), default by time of day: light during daytime, dark at
   * night. Once the user toggles, the effect persists their choice and this
   * time-of-day default no longer applies.
   */
  private static resolveInitialTheme(): boolean {
    const stored = localStorage.getItem('theme');
    if (stored === 'dark' || stored === 'light') {
      return stored === 'dark';
    }
    const hour = new Date().getHours();
    const isDaytime = hour >= 7 && hour < 19;
    return !isDaytime;
  }

  readonly isDark = this._isDark.asReadonly();

  constructor() {
    effect(() => {
      const dark = this._isDark();
      localStorage.setItem('theme', dark ? 'dark' : 'light');
      document.documentElement.classList.toggle('dark', dark);
    });
  }

  toggle(): void {
    this._isDark.update(v => !v);
  }
}